/**
 * @file back-top.class.js
 * @description Defines the BackTop class that adds functionality for scrolling
 * to the top of the window when a button is clicked.
 */

class BackTop {
  constructor(debug = false) {
    this.config = {
      breakpoint: 600,
      speed: 600
    };
    this.elBackTop = Helper.getElement('[data-back-top]');
    this.bindEvents();
    this.debug();
  }

  /**
   * @description Binds the window scroll event to check if the user has scrolled past
   * the breakpoint defined in config.breakpoint.
   * 
   * Binds the click event to elBackTop to scroll the user to the top of the document.
   */
  bindEvents() {
    if (this.elBackTop.childElementCount > 0) {
      window.addEventListener('scroll', () => { this.handleScroll() });
      this.elBackTop.addEventListener('click', (event) => { this.animateTop(event) });
    }
  }

  /**
   * @description Checks whether the user is scrolled past the breakpoint defined
   * in config.breakpoint.
   */
  handleScroll() {
    let offsetTop = window.pageYOffset;

    if (offsetTop > this.config.breakpoint) {
      this.elBackTop.classList.add('is-active');
    } else {
      this.elBackTop.classList.remove('is-active');
    }
  }

  /**
   * @description Scrolls the user to the top of the window.
   */
  animateTop(event) {
    event.preventDefault();
    //TODO: Implement cross-browser way of accomplishing this.
    window.scrollTo({
      'behavior': 'smooth',
      'left': 0,
      'top': 0
    })
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c BackTop', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    }
  }
}
